// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import issueEvidenceEntity from './entities/issue-evidence.json';
import issueEvidenceMenu from '../pages/issue-evidence/menu.json';
import issueEvidenceFullForm from '../pages/issue-evidence/forms/full.json';
import issueEvidenceContextForm from '../pages/issue-evidence/forms/context.json';
import issueEvidenceMiniForm from '../pages/issue-evidence/forms/mini.json';
import issueEvidenceLookupForm from '../pages/issue-evidence/forms/lookup.json';
import issueEvidenceTableView from '../pages/issue-evidence/views/table.json';
import issueEvidenceCardsView from '../pages/issue-evidence/views/cards.json';
import issueEvidenceDashboardView from '../pages/issue-evidence/views/dashboard.json';

/** Тип запису «Доказ проблеми» зі сторінками пакета: меню, форми та подання з pages/issue-evidence/. */
export const issueEvidenceDefinition: IRecordTypeDefinition = {
  ...issueEvidenceEntity,
  views: assembleViewSet({
      table: issueEvidenceTableView,
      cards: issueEvidenceCardsView,
      dashboard: issueEvidenceDashboardView,
  }),
  form: issueEvidenceFullForm,
  forms: { full: issueEvidenceFullForm, context: issueEvidenceContextForm, mini: issueEvidenceMiniForm, lookup: issueEvidenceLookupForm },
  menu: issueEvidenceMenu,
} as IRecordTypeDefinition;
